import { render, staticRenderFns } from "./DictionaryType.vue?vue&type=template&id=56c59379&scoped=true"
import script from "./DictionaryType.vue?vue&type=script&lang=js"
export * from "./DictionaryType.vue?vue&type=script&lang=js"
import style0 from "./DictionaryType.vue?vue&type=style&index=0&id=56c59379&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c59379",
  null
  
)

export default component.exports